export default {
  name: '',
  emits: ['onKeyEnter'],
  computed: {
    attrs() {
      return this.Data.attrs || {};
    },
  },

  methods: {
    onClick(e) {
      if (this.events.click) this.events.click(e);
    },
    onBlur(e) {
      if (this.events.blur) this.events.blur(e);
    },
    onFocus(e) {
      if (this.events.focus) this.events.focus(e);
    },
    onChange(value) {
      if (this.events.change) this.events.change(value);
    },
    onKeyEnter() {
      this.$emit('onKeyEnter');
    },
  },
};
